const $ = require('jquery');

const ApiError = require('./utils/ApiError');

const constants = require('./data/constants');
const User = require('./data/User');
const File = require('./data/File');
const Files = require('./data/Files');
const Segment = require('./data/Segment');

const commands = {
  login: 'LOGIN',
  fileList: 'FILELIST',
  match: 'MATCH',
  createFile: 'CREATEFILE',
  deleteFile: 'DELETEFILE',
  fileContents: 'DIFF',
  addSegment: 'ADD',
  changeSegment: 'CHANGE',
  deleteSegment: 'DELETE',
  activateFile: 'ActivateFile',
  addStreet: 'ADDSTREET&CHECK=true',
  addStreetNoCheck: 'ADDSTREET&CHECK=false'
};

/**
 * @class Api
 * Interface to the OpenLR server
 */
class Api {
  constructor(localization) {
    this.serverUrlTomTom = 'https://detoureditor.maptrip.de/server/api/tomtom/';
    this.serverUrlHere = 'https://detoureditor.maptrip.de/server/api/here/';
    this.serverUrlOsm = 'https://detoureditor.maptrip.de/server/api/osm/';
    this.serverUrl = 'https://editor.maptrip.de/112/server-alpha/';
    this.serverUrlFWW = 'https://detoureditor.maptrip.de/server/api/fww/';
    this.serverUrlTomTomStaging = 'https://detoureditor.maptrip.de/server/api/tomtom-staging/'; //'http://168.119.189.12:5500/';
    this.STATUS_OK = 'OK';
    this.localization = localization;
  }

  setDefaultServer(server) {
    localStorage.setItem(constants.PROVIDER_STORAGE_KEY, server);
  }

  /**
   * Issues a login command to the server and creates a User object if it succeeds
   *
   * @param username
   * @param password
   * @param rememberMe
   * @return {Promise<any>}
   */
  login(username, password, rememberMe) {
    return new Promise((resolve, reject) => {

      const url = constants.BASE_URL_MANAGEMENT + 'api/authenticate';

      $.ajax({
        type: 'POST',
        url: url,
        data: JSON.stringify({
          application: "detour",
          username: username,
          password: password,
          rememberMe: rememberMe
        }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (result) {
          resolve(new User('n/a', username, result.id_token, 'n/a', rememberMe));
        },
        error: function (result) {
          reject(result);
        }
      });
    });
  }

  getUserData(sessionid) {

    return new Promise((resolve, reject) => {
      const url = constants.BASE_URL_MANAGEMENT + 'api/user-data';

      $.ajax({
        type: 'GET',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + sessionid
        },
        success: function success(r) {
          var result;
          try {
            result = $(r);
            return resolve(result[0]);
          } catch (e) {
            if (e.errorcode === '6') {
              return reject(false);
            }
            return reject(e);
          }
        },
        error: function(result) {
          reject(result);
        },
        dataType: 'json'
      });
    })

  }

  initPasswordReset(email, callbackUrl) {

    return new Promise((resolve, reject) => {
      const url = constants.BASE_URL_MANAGEMENT + 'api/account/reset-password/init/fromapp';

      $.ajax({
        type: 'POST',
        url: url,
        data: {
          callbackUrl: callbackUrl,
          mail: email,
          desiredProduct: "detour"
        },
        success: function() {
          resolve();
        },
        error: function(result) {
          reject(result);
        }
      });

    });

  }

  getUserOptions(sessionId) {

    return new Promise((resolve, reject) => {
      const url = constants.BASE_URL_MANAGEMENT + 'api/user-options/own/product/detour';
      $.ajax({
        type: 'GET',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + sessionId
        },
        success: function(data) {
          resolve(data);
        },
        error: function(error) {
          reject(error);
        }
      })
    })
  }

  /**
   * Gets a list of files based on the current session ID
   * @param sessionId
   * @return {Promise<any>}
   */
  getFileList(sessionId) {
    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        this.buildUrl('fileList'), 'GET', null, sessionId
      ).then((response) => {
        const files = new Files();

        $(response).find('file').each(function () {
          files.add(new File($(this).attr('id'), $(this).attr('name'), $(this).attr('ver'), $(this).attr('user'), $(this).attr('company'), null, $(this).attr('active')));
        });

        resolve(files);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getFileListByAPI(sessionId) {
    return new Promise((resolve, reject) => {
      let url = `https://api.maptrip.de/v1/detour/file/all?provider=${localStorage.getItem(constants.PROVIDER_STORAGE_KEY)}`;
      $.ajax({
        url: url,
        headers: {
          'Authorization': 'Bearer ' + sessionId
        },
        dataType: 'json'
      })
        .done((response) => {
          console.log(response);
          const files = new Files();


          resolve(response);
        })
        .fail((error) => {
          console.log(error);
          reject(error);
        })
    })
  }

  /**
   * Gets the contents of a file and returns a list of segments
   *
   * @param sessionId
   * @param {File} file
   * @return {Promise<File>}
   */
  getFileContents(sessionId, file) {
    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        this.buildUrl('fileContents'), 'GET', {FILEID: file.id, VER: -1}, sessionId
      ).then((response) => {
        const segments = [];
        let self = this;
        const geometryAttributes = ["MAP_TYPE", "NAME", "RS", "TA", "TYPE"];
        $(response).find('delta[op="change"]').each((index, element) => {
          let polyline = $(element).attr('polyline');
          const olr = $(element).attr('olr');

          const attributesRaw = $(element).find('att');
          const id = $(element).attr('id');
          polyline = polyline.split(',');

          const coordinates = Api.extractPolylineCoordinates(polyline);

          const attributes = {};

          if(olr === "Geometry") {
            attributes[constants.SEGMENT_MODIFIED_STREET] = {};
          }
          let highestValidity = 0;


          attributesRaw.each(function () {
            let name = $(this).attr('name');
            if(olr === "Geometry" && geometryAttributes.includes(name)) {
              attributes[constants.SEGMENT_MODIFIED_STREET][name] = $(this).attr('val');
            } else if(name === 'detourEditor_turnArrowCoords') {
              attributes[name] = self.stringToPolyline($(this).attr('val'));
            } else {
              attributes[name] = $(this).attr('val');
            }

            if($(this).attr('validity') > highestValidity) {
              highestValidity = $(this).attr('validity');
            }
          });

          if(attributes[constants.SEGMENT_MODIFIED_STREET]) {
            let keys = Object.keys(attributes[constants.SEGMENT_MODIFIED_STREET]);
            if(!geometryAttributes.every(attr => keys.includes(attr))) {
              let missingKeys = geometryAttributes.filter(attr => !keys.includes(attr));
              missingKeys.forEach(key => {
                  attributes[constants.SEGMENT_MODIFIED_STREET][key] = '';
              });
            }
          }

          attributes.validity = highestValidity;

          segments.push(new Segment(id, coordinates, olr, attributes, constants.SEGMENT_PUBLISHED));
        });

        resolve(new File(file.id, file.name, file.version, file.user, file.company, segments));
      }).catch((error) => {
        reject(error);
      });
    });
  }

  /**
   * Matches a set of coordinates belonging to a segment
   *
   * @param sessionId
   * @param segment
   *
   * @return {Promise<any>}
   */
  matchSegment(sessionId, segment, fileId) {
    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        this.buildUrl('match'), 'GET', {POLYLINE: segment.coordinatesString, FILEID: fileId}, sessionId
      ).then((response) => {
        const polyline = $(response).find('matched').attr('polyline').split(',');
        const olr = $(response).find('matched').attr('olr');

        const coordinates = Api.extractPolylineCoordinates(polyline);

        Promise.all([this.getTurnArrow(olr), this.getAverageSpeedByPolyline(polyline, fileId, sessionId)])
          .then(results => {
            if(results[0]) {
              segment.attributes.detourEditor_turnArrowCoords = results[0];
            }

            segment.attributes.detourEditor_originalRoadSpeed = results[1];
          })
          .finally(() => {
            resolve(new Segment(null, coordinates, olr, segment.attributes, constants.SEGMENT_NEW));
          });

      }).catch((error) => {
        reject(error);
      });
    });
  }


  checkAddStreet(sessionId, fileId, segment) {
    return new Promise((resolve, reject) => {
      let url = `${this.getServerUrl()}?CMD=ADDSTREET&CHECK=true&FILEID=${fileId}&SNAP_DIST=5&ACAO=true`;

      this.makeHTTPRequest(
        url, 'GET', {POLYLINE: segment.coordinatesString}, sessionId
      ).then((response) => {
        const polyline = $(response).find('street').attr('polyline').split(',');

        const attributes = Api.extractStreetAttributes($(response).find('att'));
        const snapedStart = $(response).find('street').attr('snapedStart');
        const snapedEnd = $(response).find('street').attr('snapedEnd');

        attributes.snapedStart = snapedStart;
        attributes.snapedEnd = snapedEnd;

        const coordinates = Api.extractPolylineCoordinates(polyline);

        let newSegment = new Segment(null, coordinates, '', segment.attributes, constants.SEGMENT_NEW);
        newSegment.type = constants.SEGMENT_MODIFIED_STREET;
        newSegment._attributes.modified_street = attributes;

        resolve(newSegment);

      }).catch((error) => {
        reject(error);
      })
    })
  }

  addStreet(sessionId, fileId, segment) {
    return new Promise((resolve, reject) => {

      let url = `${this.getServerUrl()}?CMD=ADDSTREET&ACAO=true&CHECK=false&FILEID=${fileId}`;

      let modifiedStreetArgs = segment.attributes.modified_street;

      const args = {
      };

      args.POLYLINE = segment.coordinatesString;

      let index = 1;

      Object.keys(segment.attributes).forEach((name) => {
        if(name === constants.SEGMENT_MODIFIED_STREET) return;
        if(name === "validity") return;
        if(name === "" || segment.attributes[name] === "") return;
        args[`ATT${index}`] = name;
        args[`VAL${index}`] = segment.attributes[name];
        index += 1;
      });

      Object.keys(modifiedStreetArgs).forEach((name) => {
        if(name === 'fltSnapDist') return;
        if(name === "validity") return;
        //if(name === "" || segment.attributes.modified_street[name] === '') return;
        args[`ATT${index}`] = name;
        args[`VAL${index}`] = segment.attributes.modified_street[name];
        index += 1;
      });

      args['NUMATT'] = index-1;

      this.makeHTTPRequest(
        url, 'GET', args, sessionId
      ).then((response) => {

        const id = $(response).find('STATUS').attr('id');

        resolve(new Segment(
          id,
          segment.coordinates,
          segment.olr,
          segment.attributes,
          constants.SEGMENT_PUBLISHED,
        ));

      }).catch((error) => {
        reject(error);
      })

    })
  }

  checkAddGeofence(sessionId, fileId, segment) {
    return new Promise((resolve, reject) => {
      let url = `${this.getServerUrl()}?CMD=ADDGEOFENCE&CHECK=true&FILEID=${fileId}&POINT=${segment.coordinatesString}&FUNCTION=AdjustGpsAngle&ANGLE=180&RADIUS=20&ACAO=true`;

      $.ajax({
        url: url,
        headers: {
          'Authorization': 'Bearer ' + sessionId
        },
        dataType: 'xml'
      })
        .done((response) => {

          let newSegment = new Segment(
            null,
            segment.coordinates,
            '',
            segment.attributes,
            constants.SEGMENT_NEW
          );

          newSegment.type = constants.SEGMENT_TYPE_GEOFENCE;

          resolve(newSegment);
        })
        .fail((error) => {
          let code = -1;
          let errorMessage = `Request to server failed with status ${error.status}`;

          const status = $(error.responseXML).find('STATUS')[0];

          if ($(status).attr('errorCode')) {
            code = $(status).attr('errorCode');
          }

          if ($(status).attr('message')) {
            errorMessage = $(status).attr('message');
          }
          reject(new ApiError(code, errorMessage, this.localization));
        })
    })
  }

  addGeofence(sessionId, fileId, segment) {
    return new Promise((resolve, reject) => {

      //let url = `${this.getServerUrl()}?CMD=ADDGEOFENCE&ACAO=true&CHECK=false&FILEID=${fileId}`;

      let url = `${this.getServerUrl()}?CMD=ADDGEOFENCE&CHECK=false&FILEID=${fileId}&POINT=${segment.coordinatesString}&FUNCTION=AdjustGpsAngle&ANGLE=${segment.attributes.Angle}&RADIUS=${segment.attributes.Radius}&ACAO=true`;


      const args = {
      };

      args.POLYLINE = segment.coordinatesString;

      let index = 1;

      Object.keys(segment.attributes).forEach((name) => {
        if(name === constants.SEGMENT_MODIFIED_STREET) return;
        if(name === "" || segment.attributes[name] === "") return;
        if(name.toLocaleLowerCase() === "function" || name.toLocaleLowerCase() === "angle" || name.toLocaleLowerCase() === "radius") return;
        args[`ATT${index}`] = name;
        args[`VAL${index}`] = segment.attributes[name];
        index += 1;
      });

      args['NUMATT'] = index-1;

      this.makeHTTPRequest(
        url, 'GET', args, sessionId
      ).then((response) => {

        const id = $(response).find('STATUS').attr('id');

        resolve(new Segment(
          id,
          segment.coordinates,
          segment.olr,
          segment.attributes,
          constants.SEGMENT_PUBLISHED,
        ));

      }).catch((error) => {
        reject(error);
      })
    })
  }

  /**
   * Adds a segment to a file
   *
   * @param sessionId
   * @param fileId
   * @param {Segment} segment
   * @param preMatched
   *
   * @return {Promise<any>}
   */
  addSegment(sessionId, fileId, segment, preMatched) {
    return new Promise((resolve, reject) => {
      const args = {
        OLR: segment.olr,
        FILEID: fileId,
        NUMATT: segment.attributesCount,
      };

      if (preMatched) {
        args.POLYLINE = segment.coordinatesString;
      }

      let index = 1;

      let validity = segment.attributes.validity;

      Object.keys(segment.attributes).forEach((name) => {
        if(name === "validity") return;
        if(name === '') return;
        if(name === 'checkCode') return;
        if(name === 'checkDesc') return;
        if(name === "maxDist") return;
        args[`ATT${index}`] = name;

        if(name === 'detourEditor_turnArrowCoords') {
          args[`VAL${index}`] = this.polylineToString(segment.attributes[name]);
        } else {
          args[`VAL${index}`] = segment.attributes[name];
        }
        args[`VALIDITY${index}`] = validity;
        index += 1;
      });

      this.makeHTTPRequest(
        this.buildUrl('addSegment'), 'POST', args, sessionId
      ).then((response) => {
        const id = $(response).find('STATUS').attr('id');

        resolve(new Segment(
          id,
          segment.coordinates,
          segment.olr,
          segment.attributes,
          constants.SEGMENT_PUBLISHED,
        ));
      }).catch((error) => {
        reject(error);
      });
    });
  }

  checkDivideStreet(sessionId, fileId, coordinate) {
    return new Promise((resolve, reject) => {
      let url = `${this.getServerUrl()}?CMD=DIVIDESTREET&ACAO=true&CHECK=true&FILEID=${fileId}&POINT=${coordinate._x},${coordinate._y}&SNAP_DIST=5`;

      $.ajax({
        url: url,
        headers: {
          'Authorization': 'Bearer ' + sessionId
        },
        dataType: 'xml'
      })
        .done((response) => {

          let polyline = $(response).find('delta').attr('polyline').split(',');

          let coordinates = [new IWCoordinate(polyline[0], polyline[1], IWCoordinate.WGS84)];
          const attributesRaw = $(response).find('att');
          const snappedEnd = $(response).find('delta').attr('snapedEnd');
          const snappedStart = $(response).find('delta').attr('snapedStart');

          const attributes = {};

          attributesRaw.each(function () {
            let name = $(this).attr('name');
            attributes[name] = $(this).attr('val');
          });

          attributes.snapedStart = snappedStart;
          attributes.snapedEnd = snappedEnd;

          resolve(new Segment(
            null,
            coordinates,
            '',
            attributes,
            constants.SEGMENT_NEW
          ));
        })
        .fail((error) => {
          let code = -1;
          let errorMessage = `Request to server failed with status ${error.status}`;

          const status = $(error.responseXML).find('STATUS')[0];

          if ($(status).attr('errorCode')) {
            code = $(status).attr('errorCode');
          }

          if ($(status).attr('message')) {
            errorMessage = $(status).attr('message');
          }
          reject(new ApiError(code, errorMessage, this.localization));
        })
    })
  }

  divideStreet(sessionId, fileId, segment) {
    return new Promise((resolve, reject) => {
      let coordinate = segment.coordinates[0];
      let url = `${this.getServerUrl()}?CMD=DIVIDESTREET&ACAO=true&CHECK=false&FILEID=${fileId}&POINT=${coordinate._x},${coordinate._y}&SNAP_DIST=5`;

      const args = {
      };

      let index = 1;

      Object.keys(segment.attributes).forEach((name) => {
        if(name === constants.SEGMENT_MODIFIED_STREET) return;
        if(name === "validity") return;
        if(name === "" || segment.attributes[name] === "") return;
        if(name === 'MAP_TYPE') return;
        if(name === 'fltSnapDist' || name === 'snapedEnd' || name === 'snapedStart') return;

        args[`ATT${index}`] = name;
        args[`VAL${index}`] = segment.attributes[name];
        index += 1;
      });

      args['NUMATT'] = index-1;

      $.ajax({
        url: url,
        data: args,
        headers: {
          'Authorization': 'Bearer ' + sessionId
        },
        dataType: 'xml'
      })
        .done((response) => {
          let segments = [];

          $(response).find('delta[op="change"]').each((index, element) => {
            const geometryAttributes = ["MAP_TYPE", "NAME", "RS", "TA", "TYPE"];
            let polyline = $(element).attr('polyline').split(',');
            let coordinates = Api.extractPolylineCoordinates(polyline);
            const attributesRaw = $(element).find('att');
            const snappedEnd = $(element).attr('snapedEnd');
            const snappedStart = $(element).attr('snapedStart');
            const id = $(element).attr('id');
            const olr = $(element).attr('olr');

            const attributes = {};
            if(olr === "Geometry") {
              attributes[constants.SEGMENT_MODIFIED_STREET] = {};
            }

            attributesRaw.each(function () {
              let name = $(this).attr('name');
              if(olr === "Geometry" && geometryAttributes.includes(name)) {
                attributes[constants.SEGMENT_MODIFIED_STREET][name] = $(this).attr('val');
              } else {
                attributes[name] = $(this).attr('val');
              }
            });

            attributes.snapedStart = snappedStart;
            attributes.snapedEnd = snappedEnd;

            segments.push(new Segment(id, coordinates, olr, attributes, constants.SEGMENT_PUBLISHED));
          });

          resolve(segments);

        })
        .fail((error) => {
          let code = -1;
          let errorMessage = `Request to server failed with status ${error.status}`;

          const status = $(error.responseXML).find('STATUS')[0];

          if ($(status).attr('errorCode')) {
            code = $(status).attr('errorCode');
          }

          if ($(status).attr('message')) {
            errorMessage = $(status).attr('message');
          }
          reject(new ApiError(code, errorMessage, this.localization));
        })
    })
  }

  /**
   * Adds a segment to a file
   *
   * @param sessionId
   * @param fileId
   * @param segment
   *
   * @return {Promise<any>}
   */
  changeSegment(sessionId, fileId, segment) {
    return new Promise((resolve, reject) => {
      const args = {
        FILEID: fileId,
        ID: segment.id,
        NUMATT: segment.attributesCount,
      };
      let index = 1;

      let validity = segment.attributes.validity;

      Object.keys(segment.attributes).forEach((name) => {
        if(name === "validity") return;
        if(name === "warningCode") return;
        if(name === '') return;
        args[`ATT${index}`] = name;

        if(name === 'detourEditor_turnArrowCoords') {
          args[`VAL${index}`] = this.polylineToString(segment.attributes.detourEditor_turnArrowCoords);
        } else {
          args[`VAL${index}`] = segment.attributes[name];
        }

        args[`VALIDITY${index}`] = validity;
        index += 1;
      });

      this.makeHTTPRequest(
        this.buildUrl('changeSegment'), 'GET', args, sessionId
      ).then(() => {
        resolve(new Segment(
          segment.id,
          segment.coordinates,
          segment.olr,
          segment.attributes,
          constants.SEGMENT_PUBLISHED,
        ));
      }).catch((error) => {
        reject(error);
      });
    });
  }

  changeModifiedStreet(sessionId, fileId, segment) {
    return new Promise((resolve, reject) => {
      let url = `${this.getServerUrl()}?CMD=CHANGESTREET&ACAO=true&CHECK=false`;

      let modifiedStreetArgs = segment.attributes.modified_street;

      const args = {
        FILEID: fileId,
        ID: segment.id
      };

      let index = 1;
      let validity = segment.attributes.validity ? segment.attributes.validity : 0;

      Object.keys(segment.attributes).forEach((name) => {
        if(name === constants.SEGMENT_MODIFIED_STREET) return;
        if(name === "warningCode") return;
        if(name === "validity") return;
        if(name === '') return;
        args[`ATT${index}`] = name;
        args[`VAL${index}`] = segment.attributes[name];
        args[`VALIDITY${index}`] = validity;
        index += 1;
      });

      Object.keys(modifiedStreetArgs).forEach((name) => {
        if(name === 'fltSnapDist') return;
        if(name === "validity") return;
        if(name === '' || segment.attributes.modified_street[name] === '') return;
        args[`ATT${index}`] = name;
        args[`VAL${index}`] = segment.attributes.modified_street[name];
        args[`VALIDITY${index}`] = validity;
        index += 1;
      });

      args['NUMATT'] = index-1;

      this.makeHTTPRequest(
        url, 'GET', args, sessionId
      ).then((response) => {
        resolve(new Segment(
          segment.id,
          segment.coordinates,
          segment.olr,
          segment.attributes,
          constants.SEGMENT_PUBLISHED,
        ));
      }).catch((error) => {
        reject(error);
      });

    });
  }

  /**
   * Adds a segment to a file
   *
   * @param sessionId
   * @param fileId
   * @param segment
   *
   * @return {Promise<any>}
   */
  deleteSegment(sessionId, fileId, segment) {
    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        this.buildUrl('deleteSegment'), 'POST', {FILEID: fileId, ID: segment.id }, sessionId
      ).then(() => {
        resolve(true);
      }).catch((error) => {
        reject(error);
      });
    });
  }


  deleteModifyStreetSegment(sessionId, fileId, segment) {
    let url = `${this.getServerUrl()}?CMD=DELETESTREET&ACAO=true`;

    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        url, 'GET', {FILEID: fileId, ID: segment.id}, sessionId
      ).then(() => {
        resolve(true);
      }).catch((error) => {
        reject(error);
      })
    })
  }

  checkFile(sessionId, fileId, setNewMapVersion, checkAll, writeMapLabScript) {
    let url = `${this.getServerUrl()}?CMD=CheckFileOnCurrentMapdata&ACAO=true`;

    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        url, 'GET', {FILEID: fileId, SetNewMapVersion: setNewMapVersion, CheckAll: checkAll, WriteMapLabScript: writeMapLabScript}, sessionId
      ).then(result => {
        const segments = [];

        $(result).find('delta[op="change"]').each((index, element) => {

          let segment = {};
          let attributes  = {};
          let attributesRaw = $(element).find('att');
          attributesRaw.each(function () {
            let name = $(this).attr('name');
            attributes[name] = $(this).attr('val');
          });


          let polyline = $(element).attr('new_polyline');
          if(!polyline) polyline = $(element).attr('polyline');
          polyline = polyline.split(',');

          let coordinates = Api.extractPolylineCoordinates(polyline);
          let id = $(element).attr('id');
          let olr = $(element).attr('olr');
          attributes.checkCode = $(element).attr('check_value');
          attributes.checkDesc = $(element).attr('check_descr');
          attributes.maxDist = $(element).attr('maxDist');
          //segment.attributes = attributes;
          segments.push(new Segment(id, coordinates, olr, attributes, constants.SEGMENT_PUBLISHED));
          //segments.push(segment);
        });
        resolve(segments);
      }).catch(error => {
        reject(error);
      })
    })
  }

  getTurnArrow(olr) {
    let url = `${this.getServerUrl()}?CMD=GetTurnArrow&olr=${encodeURIComponent(olr)}&ACAO=true`;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        dataType: 'xml'
      })
        .done((response) => {
          const polyline = $(response).find('matched').attr('polyline').split(',');
          const coordinates = Api.extractPolylineCoordinates(polyline, true);
          resolve(coordinates);
        })
        .fail((error) => {
          resolve(null);
        });
    })
  }

  getAverageSpeedByPolyline(polyline, fileId, sessionId) {
    let url = `${this.getServerUrl()}?CMD=GetAttribute&ATTRIBUTE=AVGSPEED&FILEID=${fileId}&POLYLINE=${polyline}&ACAO=true`;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        headers: {
          'Authorization': 'Bearer ' + sessionId
        },
        dataType: 'xml'
      })
        .done(response => {
          let averageSpeed = $(response).find('ATTRIBUTE').attr('combinedValue');
          averageSpeed = Math.round(averageSpeed);
          resolve(averageSpeed);
        })
        .fail(error => {
          console.error(error);
          reject(error);
        })
    })
  }

  getAverageSpeedBySegment(segmentId, fileId, sessionId) {
    let url = `${this.getServerUrl()}?CMD=GetAttribute&ATTRIBUTE=AVGSPEED&FILEID=${fileId}&ID=${segmentId}&ACAO=true`;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        headers: {
          'Authorization': 'Bearer ' + sessionId
        },
        dataType: 'xml'
      })
        .done(response => {
          let averageSpeed = $(response).find('ATTRIBUTE').attr('combinedValue');
          averageSpeed = Math.round(averageSpeed);
          resolve(averageSpeed);
        })
        .fail(error => {
          console.error(error);
          reject(error);
        })
    })
  }

  getMapBuildVersion() {
    let url = `${this.getServerUrl()}?CMD=DATA_INFO&ACAO=true`;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        dataType: 'xml'
      })
        .done((response) => {
          let buildVersion = $(response).find('ROUTING_DATA').attr('BuildVersion');
          resolve(buildVersion);
        })
        .fail((error) => {
          let code = -1;
          let errorMessage = `Request to server failed with status ${error.status}`;

          const status = $(error.responseXML).find('STATUS')[0];

          if ($(status).attr('errorCode')) {
            code = $(status).attr('errorCode');
          }

          if ($(status).attr('message')) {
            errorMessage = $(status).attr('message');
          }
          reject(new ApiError(code, errorMessage, this.localization));
        });
    })
  }


  /**
   * Creates a file on the server
   *
   * @param {string} sessionId
   * @param {string} fileName
   * @param {string} user
   * @param {string} company
   *
   * @return {Promise<File>}
   */
  createFile(sessionId, fileName, user, company) {
    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        this.buildUrl('createFile'), 'GET', { FILENAME: fileName }, sessionId
      ).then((response) => {
        const id = $(response).find('STATUS').attr('fileid');

        resolve(new File(id, fileName, 0, user, company));
      }).catch((error) => {
        reject(error);
      });
    });
  }

  /**
   * Creates a file on the server
   *
   * @param {String} sessionId
   * @param {Integer} fileId
   *
   * @return {Promise<any>}
   */
  deleteFile(sessionId, fileId) {
    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        this.buildUrl('deleteFile'), 'GET', { FILEID: fileId }, sessionId
      ).then(() => {
        resolve(true);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  activateFile(sessionId, fileId) {
    return new Promise((resolve, reject) => {
      this.makeHTTPRequest(
        this.buildUrl('activateFile'), 'GET', { FileId: fileId }, sessionId
      ).then(() => {
        resolve(true);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getPriorityAttributes(token) {

    return new Promise((resolve, reject) => {
      $.ajax({
        url: "https://api.maptrip.de/v1/detour/attribute/prioritize",
        headers: {
          'Authorization': 'Bearer ' + token
        },
        dataType: 'json'
      })
        .done((response) => {
          resolve(response);
        })
        .fail((error) => {
          reject(error);
        })
    })
  }

  getPenalizeAttributes(token) {

    return new Promise((resolve, reject) => {
      $.ajax({
        url: "https://api.maptrip.de/v1/detour/attribute/penalize",
        headers: {
          'Authorization': 'Bearer ' + token
        },
        dataType: 'json'
      })
        .done((response) => {
          resolve(response);
        })
        .fail((error) => {
          reject(error);
        })
    })
  }

  uploadBulkSegments(sessionId, segments, fileId) {
    let provider = localStorage.getItem(constants.PROVIDER_STORAGE_KEY);
    if(Api.isDevelopment()) {
      provider = "tomtom_staging";
    }
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `https://api.maptrip.de/v1/detour/file/${fileId}/segments?provider=${provider}`,
        headers: {
          'Authorization': 'Bearer ' + sessionId
        },
        dataType: 'json',
        method: 'POST',
        contentType: "application/json",
        data: JSON.stringify(segments),
        statusCode: {
          200: function() {
            resolve("200 OK");
          },
          201: function() {
            resolve("201 Created")
          },
          400: function() {
            reject("HttpCode: 400");
          },
          401: function() {
            reject("401 Unauthorized")
          },
          403: function() {
            reject("Unauthorized")
          },
          404: function() {
            reject("404 Not Found")
          },
          500: function() {
            reject("500 Server Error")
          },
          504: function() {
            reject("504 Timeout")
          }

        }
      })/*
        .done((response) => {
          console.log(response);
          resolve(response);
        })
        .fail((error) => {
          console.log(error);
          reject(error)
        })*/
    })

  }

  /*
   * General method that does a HTTP request to the server
   * @private
   *
   * @param url
   * @param method
   * @param data
   * @return {Promise<any>}
   */
  makeHTTPRequest(url, method, data, token) {
    return new Promise((resolve, reject) => {
      // noinspection JSIgnoredPromiseFromCall
      $.ajax({
        method, url, data, contentType: 'text/plain', dataType: 'xml', headers: {
          'Authorization': 'Bearer ' + token
        }
      })
        .done((responseXML) => {
          const status = $(responseXML).find('STATUS')[0];

          if ($(status).attr('value') !== this.STATUS_OK) {
            let code = -1;
            let errorMessage = 'Failed with undefined error message';

            if ($(status).attr('errorCode')) {
              code = $(status).attr('errorCode');
            }

            if ($(status).attr('message')) {
              errorMessage = $(status).attr('message');
            }

            reject(new ApiError(code, errorMessage, this.localization));
          }

          resolve($(responseXML).find('IWXML')[0]);
        })
        .fail((jqXHR) => {
          let code = -1;
          let errorMessage = `Request to server failed with status ${jqXHR.status}`;

          const status = $(jqXHR.responseXML).find('STATUS')[0];

          if ($(status).attr('errorCode')) {
            code = $(status).attr('errorCode');
          }

          if ($(status).attr('message')) {
            errorMessage = $(status).attr('message');
          }
          reject(new ApiError(code, errorMessage, this.localization));
        });
    });
  }

  buildUrl(command, server) {
    let serverUrl = this.getServerUrl(server);

    if (!Object.prototype.hasOwnProperty.call(commands, command)) {
      throw new Error(`Command "${command}" is not defined`);
    }

    return `${serverUrl}?CMD=${commands[command]}&ACAO=true`;
  }

  getServerUrl(server) {

    //return this.serverUrlTomTomStaging;

    if(Api.isStaging()) {
      let debugUrl = localStorage.getItem('debugServerUrl');
      if(debugUrl && debugUrl !== '' && debugUrl !== 'undefined') {
        console.log(debugUrl);
        return debugUrl;
      }
    } else if(Api.isDevelopment()) {
      return this.serverUrlTomTomStaging;
    }
    //return this.serverUrlTomTomStaging;

    if(!server) {
      server = localStorage.getItem(constants.PROVIDER_STORAGE_KEY);
    }

    if(server === constants.PROVIDER_FWW) {
      return this.serverUrlFWW;
    }

    if(!server) return this.serverUrlTomTom;

    switch (server) {
      case constants.PROVIDER_TOMTOM:
      default:
        return this.serverUrlTomTom;

      case constants.PROVIDER_HERE:
        return this.serverUrlHere;

      case constants.PROVIDER_OSM:
        return this.serverUrlOsm;
    }
  }

  polylineToString(polyline) {
    return polyline.map((coordinateTemp) => {
      const coordinate = coordinateTemp.toWGS84();
      return `${coordinate.getX()},${coordinate.getY()}`;
    }).join(';');
  }

  stringToPolyline(string) {
    return string.split(';').map((coordinate) => {
      const coordinateTemp = coordinate.split(',');
      return new IWCoordinate(coordinateTemp[0], coordinateTemp[1], IWCoordinate.WGS84);
    });
  }

  static extractPolylineCoordinates(polyline, useMercator) {
    let coordType = IWCoordinate.WGS84;

    if(useMercator) {
      coordType = IWCoordinate.MERCATOR;
    }

    return polyline.reduce((reduceCoordinates, coordinate, index) => {
      if (index % 2 === 0) {
        reduceCoordinates.push(
          new IWCoordinate(polyline[index], polyline[index + 1], coordType).toWGS84(),
        );
      }

      return reduceCoordinates;
    }, []);
  }

  static extractStreetAttributes(attributes) {
    let obj = {};

    attributes.each((i, attr) => {
      obj[$(attr).attr('name')] = $(attr).attr('value');
    });

    return obj;
  }

  static isStaging() {
    return window.location.href.includes('localhost') || window.location.pathname.includes('staging');
  }

  static isDevelopment() {
    return window.location.href.includes('development');
  }
}

module.exports = Api;
